import advisorIcon from '@public/flaticons/advisor.svg';
import dollarShinyIcon from '@public/flaticons/dollar-shiny.svg';
import stethoscopeIcon from '@public/flaticons/stethoscope.svg';

export const contentAndImage = {
  coldCalls: {
    heading: 'No cold calls. No skeezy sales tactics. We treat you like family.',
    body:
      'You can read about Medicare and shop for Medigap or Medicare Advantage plans on our site. Or you call us if you want to talk to one of our licensed advisors.',
    image: advisorIcon,
    orientation: 'row',
    alt: 'Friendly health advisor explaining medicare.',
  },
  recommendations: {
    heading: "Our recommendations aren't influenced by commission.",
    body:
      "Like any health insurance brokerage, we make money when you enroll in a plan. Unlike other brokerages, our recommendations aren't biased by our commissions. If the right plan for you pays us nothing, we'll still recommend it.",
    image: stethoscopeIcon,
    orientation: 'row-reverse',
    alt: 'stethoscope',
  },
  bestDeal: {
    heading: 'Every year, we make sure you have the best deal.',
    body:
      "We help you decide on your first Medicare Advantage or Medigap plan. Then every year we reshop your coverage to make sure you're getting the best deal.",
    image: dollarShinyIcon,
    orientation: 'row',
    alt: 'glowing money',
  },
};
